import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'purple' | 'white';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', variant = 'white', showText = true }) => {
  const logoSrc = variant === 'purple' 
    ? '/BrandMetrics_logo1_purple.png' 
    : '/BrandMetrics_logo1_white.png';

  return (
    <div className={`logo-container ${size}`}>
      <img 
        src={logoSrc} 
        alt="Brand Metrics Logo" 
        className="logo-image"
      />
      {showText && (
        <div className="logo-text">
          <span className="brand-metrics">brand metrics</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
